export enum CarouselUpsellWidgetId {
  AddUsers = 'AddUsers',
  Feedback = 'Feedback',
  Integrations = 'Integrations',
  Loans = 'Loans',
  Payroll = 'Payroll',
  Scout = 'Scout',
  StripePayment = 'StripePayment',
  Support = 'Support',
}
